var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50016 3.49269L8.6487 2.55916C6.65008 0.367835 2.98534 1.12403 1.66243 3.87902C1.04134 5.17482 0.901215 7.04568 2.03531 9.43334C3.12785 11.7323 5.40079 14.4861 9.50016 17.4855C13.5995 14.4861 15.8713 11.7323 16.965 9.43334C18.0991 7.04441 17.9602 5.17482 17.3379 3.87902C16.015 1.12403 12.3503 0.366568 10.3516 2.55789L9.50016 3.49269ZM9.50016 19.0118C-8.70833 6.17802 3.89381 -3.83875 9.29116 1.4597C9.36241 1.52936 9.43248 1.60156 9.50016 1.6763C9.56717 1.60163 9.63689 1.5298 9.70917 1.46096C15.1053 -3.84129 27.7087 6.17675 9.50016 19.0118Z",
    fill: "current"
  })));
};
export default __webpack_public_path__ + "static/media/matchprofile.b2a80c0b.svg";
export { SvgComponent as ReactComponent };